import { Injectable } from '@angular/core';

import { VeiligheidsMeter } from '../../vm_models';

@Injectable()
export class VMDataService {
  forceNavigation = false;
  
  /* get from session */ 
  getVeiligheidsMeter(): VeiligheidsMeter {
    return JSON.parse(sessionStorage.getItem('vm'));
  }

  /* store in session */
  saveVeiligheidsMeter(veiligheidsMeter: VeiligheidsMeter) {
    sessionStorage.setItem('vm', JSON.stringify(veiligheidsMeter));
  }

  clearVeiligheidsMeter() {
    sessionStorage.removeItem('vm');
  }
}
